import { Paper, Skeleton, Stack, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { PageContainer } from "../../../../components/layout";
import PageHeader from "../../../../containers/pageheader/pageheader";
import { ApiQueries, DaymapSkeleton, StudentResults, StudentWork, TaskAttachments, TaskDetails, useStudent } from 'daymap-react';
import { RubricResults } from "../../../../components/rubrics";
import { useState } from "react";

function AssessmentTask() {
    const { taskid, studentId } = useParams();
    const navigate = useNavigate();
    const student = useStudent(Number(studentId));
    const [hasAttachments, setHasAttachments] = useState<boolean | null>(null);

    const {isPending: isPendingTaskAndOutcomes, error: errorTask, data: taskandoutcomes } = new ApiQueries.assessment.GetTaskAndOutcomes({
            studentId: Number(studentId),
            taskId: Number(taskid),
        }).ToQuery();
    if (errorTask) {
      console.log('getting taskandoutcomes error', errorTask);
    }

    const {isPending: isPendingStudentResults, error: errorResults, data: studentresults } = new ApiQueries.assessment.StudentResults({
        studentId: Number(studentId),
        taskId: Number(taskid),
    }).ToQuery();
    if (errorResults) {
      console.log('getting studentresults error: ', errorTask);
    }

    if(isPendingTaskAndOutcomes) {
      return <PageContainer>
        <DaymapSkeleton type="page"/>
      </PageContainer>
    }

    if(!taskandoutcomes) {
      console.log(errorTask);
      return <></>
    }

    return <>
      <PageHeader onBackButtonClick={() => navigate(-1)}>{taskandoutcomes.task.Name}</PageHeader>
      <PageContainer>
        <Stack gap={3}>
          <TaskDetails taskandoutcomes={taskandoutcomes} />
          {hasAttachments !== false && <Stack gap={0.5}>
            {hasAttachments && <Typography variant="h3">Attachments</Typography>}
            <TaskAttachments taskId={taskandoutcomes.task.ID} onDataLoaded={setHasAttachments} />
          </Stack>}
          {isPendingStudentResults ? (
            <Skeleton />
          ) : (
            studentresults && <>
                {studentresults.Results && <Stack gap={0.5}>
                  <Typography variant="h3">Results</Typography>
                  <Paper sx={{p: 2}}>
                    <StudentResults studentId={Number(studentId)} task={taskandoutcomes.task} outcomes={taskandoutcomes.outcomes} results={studentresults.Results} />
                  </Paper>
                </Stack>}
                {studentresults.Work && studentresults.Work.length > 0 && <Stack gap={0.5}>
                  <Typography variant="h3">{student?.Displayname}'s Work</Typography>
                  <StudentWork data={studentresults.Work} onOpenFeedbackClick={id => navigate(`/student/${studentId}/assessment/${taskid}/annotations/${id}`)} />
                </Stack>}
                {taskandoutcomes.task.RubricID && <RubricResults taskId={Number(taskid)} studentId={Number(studentId)} rubricId={taskandoutcomes.task.RubricID} />}
            </>
          )}
        </Stack>
      </PageContainer>
    </>
}

export default AssessmentTask;
